/**
 * Fractal Analysis API Integration
 * Calls backend /api/terrain/fractal-analysis endpoint
 */

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5005';

/**
 * Perform comprehensive fractal terrain analysis
 * @param {object} bbox - Bounding box {south, north, west, east}
 * @param {object} elevationData - Optional pre-fetched elevation data (avoids API call)
 * @returns {Promise<object>} Complete terrain analysis with fractal, slope, TRI, TTI
 */
export const analyzeTerrain = async (bbox, elevationData = null) => {
    try {
        if (elevationData) {
            console.log('🔬 Requesting fractal terrain analysis with pre-fetched elevation data (no API call)...');
        } else {
            console.log('🔬 Requesting fractal terrain analysis...', bbox);
        }
        
        // Include elevationData if provided to avoid duplicate API call
        const body = elevationData 
            ? { bbox, elevationData }
            : { bbox };
        
        const response = await fetch(`${API_URL}/api/v1/terrain/fractal-analysis`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-API-Key': process.env.REACT_APP_API_KEY || 'frac_d48567809b669980dc4fd133a106fee041784bac36b00dee6ab92a2326f9aad5'
            },
            body: JSON.stringify(body)
        });
        
        if (!response.ok) {
            throw new Error(`Fractal analysis API returned ${response.status}`);
        }
        
        const result = await response.json();
        
        if (!result.success) {
            throw new Error(result.error || 'Fractal analysis failed');
        }
        
        console.log('✅ Fractal analysis complete:', {
            fractal_dimension: result.data.fractal.dimension.toFixed(3),
            max_slope: result.data.slope.max_slope_degrees.toFixed(1) + '°',
            TRI: result.data.roughness.terrain_ruggedness_index.toFixed(2),
            TTI: result.data.traversability.tti_score
        });
        
        return result.data;
        
    } catch (error) {
        console.error('❌ Failed to perform fractal analysis:', error);
        throw error;
    }
};


